import { InboxListItemContent } from 'Automations/components'
import { AutomationExecution } from 'Automations/automationExecutions/types'
import { getWorkflowDescription } from 'Automations/automationExecutions/utils/getWorkflowDescription'
import { getAutomationStatusIcon } from 'Automations/automationExecutions/utils/getAutomationStatusIcon'

export const AutomationExecutionItem = ({
  automationExecution,
  isSelected,
  onClick,
  onPreload,
  'data-testid': dataTestId
}: {
  automationExecution: AutomationExecution
  isSelected: boolean
  onClick: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void
  onPreload?: () => Promise<unknown> | void
  'data-testid'?: string
}) => {
  const icon = getAutomationStatusIcon(automationExecution.status)
  const { title, description, logo } =
    getWorkflowDescription(automationExecution)

  return (
    <InboxListItemContent
      isSelected={isSelected}
      onClick={onClick}
      onPreload={onPreload}
      title={title}
      description={description}
      createdAt={automationExecution.createTime}
      statusIcon={icon}
      data-testid={dataTestId}
      icon={
        <InboxListItemContent.TaskIcon isSelected={isSelected}>
          {logo}
        </InboxListItemContent.TaskIcon>
      }
    />
  )
}
